import { StaffRate } from './staff-rate';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class EditStaffCommand {
  StaffId: string;
  EmailAddress: string;
  Password: string;
  EulaAgreedVersion: string;
  Deleted: boolean;
  RatesToMakeIneffective: string[];
  RatesToDelete: string[];
  ContactName: string;
  PhoneNumber: string;
  RoleId: string;
  SiteDepotIds: string[];
  CanEstimate: boolean;
  QuickId: string;
  RatesToAdd: StaffRate[];
  CompanyPosition: string;
}


